import {notification} from 'antd'
import type {IconType, NotificationPlacement} from 'antd/es/notification/interface'

const openToastNotification = ({title, description, placement, duration, type, onToastClick}: {title: string, description?: string, placement?: NotificationPlacement, duration?: number | null, type?: IconType, onToastClick?: () => void}) => {
  notification.open({
    message: title,
    description: description ? description : undefined,
    placement: placement ? placement : 'topRight',
    duration: duration ? duration : 4.5,
    type: type ? type : 'info',
    onClick: onToastClick ? onToastClick : undefined,
  })
}

export default openToastNotification
